import { useGetContext } from "@onefront/forrestjs-react-root";
import VaporUIShellNav from "@vapor/react-uishell/VaporUIShellNav";
import VaporAppBar from "@vapor/react-uishell/VaporAppBar";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { createComponents } from "../../utils/create-components";
import { useMenu } from "../hooks/use-menu";

export const UIShell = ({
  children = null,
  toolbarContentLeft = null,
  toolbarContentRight = null,
  title = null
}) => {
  const contentItems = useGetContext("one.layout.nav.content");
  const { isOpen, toggleIsOpen, isHidden, menuTree } = useMenu();

  const content = getDrawerContent(contentItems, menuTree);
  const menuLevels = menuTree.length ? { children: menuTree } : undefined;

  return (
    <VaporUIShellNav
      drawerOpen={isOpen}
      setDrawerOpen={toggleIsOpen}
      menuLevels={menuLevels}
      renderToolbar={
        <VaporAppBar
          disableDrawer={isHidden}
          isDrawerOpen={isOpen}
          toggleDrawer={toggleIsOpen}
          leftContent={
            <>
              <ExtendedTypography
                variant="bodyLarge500"
                sx={{ color: "white", ml: 2 }}
              >
                {title}
              </ExtendedTypography>
              {createComponents(toolbarContentLeft)}
            </>
          }
          rightContent={createComponents(toolbarContentRight)}
        />
      }
      renderDrawer={content}
      hideDrawer={isHidden}
    >
      {children}
    </VaporUIShellNav>
  );
};

function getDrawerContent(contentItems, menuTree) {
  if (contentItems.length) {
    return createComponents(contentItems);
  }

  return null;
}
